<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div>
      <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        {{ dominItem.logoName || 'Logo' }}
        <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" noAbout="noAbout"></topIcon>
      </div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="marketing-page">
        <div class="category-badge">{{ $t('con_recommended') }}</div>
        <div class="featured-article" @click="toDetail(bestItem.articleShortName)" v-if="bestItem">
          <img
              :src="bestItem?.articleImage"
              class="featured-image"
          />
          <div class="featured-content">
            <h1 class="twoHde">{{ bestItem?.articleTitle }}</h1>
            <p class="foreHde" style="font-size: 15px; margin-top: 20px" >
              {{ bestItem?.articleIntro }}
            </p>

            <div class="ccccc twoHde" v-for="(item,index) in articleList">
              {{ index + 1 }}. {{ item?.articleTitle }}
            </div>
          </div>
        </div>
        <div class="article-grid">
          <div class="article-item" v-for="(item, index) in recommendList"  @click="toDetail(item.articleShortName)">
            <img :src="item?.articleImage" class="article-image1" />
            <h3 class="fiveHde" style="text-align: left">{{ item?.articleTitle }}</h3>


          </div>
        </div>
      </div>

      <div id="app" class="article-container">
        <div class="category-badge">{{ $t('con_hot_con') }}</div>
        <div class="article-grid">
          <div class="article-item1" v-for="(item, index) in latestNewsList"  @click="toDetail(item.articleShortName)">
            <img :src="item?.articleImage"  class="article-image" />
            <h3 class="article-title twoHde">{{ item?.articleTitle }}</h3>
            <p class="article-desc threeHde">{{ item?.articleIntro }}</p>
          </div>
        </div>
      </div>
      <div class="article-container">
        <div class="category-badge">{{ $t('con_latest') }}</div>
        <div class="article-grid">
          <div class="article-item1" v-for="(item, index) in recommendList1" @click="toDetail(item.articleShortName)">
            <img :src="item?.articleImage"  class="article-image" />
            <h3 class="article-title twoHde">{{ item?.articleTitle }}</h3>
            <p class="article-desc threeHde">{{ item?.articleIntro }}</p>
          </div>
        </div>
      </div>



    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #fff">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
      </div>
      <div style="display: flex; align-items: center; justify-content: space-between; padding-right: 10%">
        <div class="logo" style="color: #ffffff">{{ dominItem.logoName || 'Logo' }}</div>
        <div>
        <img class="imgsss"  v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api"
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList:[],
      latestNewsList:[],
      articleList:[],
      articleListlast:[],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 7, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows


        console.log(this.articleList, 'articleListarticleList');
        // this.articleList.map(r => {
        //   // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        // })
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 8, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 8,

        articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
          this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: 2, pageSize: 8, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.marketing-page {
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.category-badge {
  background-image: linear-gradient(90deg,#5a6ffb 0%,#f866c6 100%);
  border-radius: 5px;
  color: white;
  font-size: 15px;
  padding: 5px 15px;
  display: inline-block;
  margin-bottom: 20px;
}

.featured-article {
  display: flex;
  margin-bottom: 30px;
}

.featured-image {
  width: 50%;
  height: 500px;
  object-fit: cover;
  margin-right: 20px;
}

.featured-content {
  width: 50%;

  h3 {
    font-size: 17px;
  }
}

.article-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.article-item {
  display: flex;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  img {
    width: 100px;
    border-radius: 5px;
    margin-right: 10px;
     height: 100px;
    object-fit: cover;
  }
}

.article-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 10px;
}

.business-title {
  background-color: #003366;
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.article-container {
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
.article-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.article-item1 {
  display: flex;
  flex-direction: column;
}

.article-item1 img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.article-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 10px;
}
.article-title {
  font-size: 15px;
  margin-bottom: 5px;
}
.article-desc {
  font-size: 12px;
  color: #666;
}


.logo {
  width: 100%;
  padding: 20px 20px 10px 10%;
  display: flex;
  box-sizing: border-box;
  font-size: 40px;
  background: #000;
  color:#fff;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  width: 100%;
  padding: 10px 10%;
  min-height: 50px;
  background: #000000;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    color: #916CE9;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color:#916CE9;;
  }
}

.buttom {
  border-top: 5px solid #004F8B;
  background: #000;
  display: flex;
  flex-direction: column;

  .logo {
    margin: 0 3% 0 10%;
    width: auto;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(6){
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.ccccc {
  margin-top: 15px;
  font-size: 15px !important;
}

</style>
